<template>
  <div
    ref="editor"
    style="color: #fff"
    class="wEditor"
    :class="currentTheme"
  ></div>
</template>
<script>
import E from "wangeditor";
export default {
  name: "editor",
  props: {
    getFullText: {
      type: Function,
      default: () => {}
    },
    content: {
      type: String,
      default: ""
    },
    type: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      curContent: "",
      className: "default"
    };
  },
  watch: {
    content(val) {
      if (val) {
        this.editor.txt.html(val);
      }
    },
    type(val) {
      if (val === 3) {
        // 查看详情禁止编辑富文本
        // this.editor.disable()
      }
    }
  },
  computed: {
    currentTheme() {
      return this.$store.getters.currentTheme;
    }
  },
  mounted() {
    let editor = new E(this.$refs.editor);
    editor.config.onchange = (html) => {
      this.curContent = html;
      // this.getFullText(html); //内容赋值
    };
    editor.config.showLinkImg = true;
    editor.config.zIndex = 8;
    editor.config.uploadImgShowBase64 = true;

    editor.create();
    this.editor = editor;
  }
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";

.wEditor{
  color: #0d121c !important
}
.w-e-menu {
  i {
    font-size: 13px;
  }
}
.wEditor > .w-e-text-container {
  resize: vertical !important;
}
.wEditor > div {
  // @include set_theme_color(background-color, page-tab-item-bg-color);
  @include set_theme_color(background-color, page-default-color);
  // background: #4b5566;
  // border: 1px solid #333 !important;
}

.wEditor {
  resize: vertical !important;
  &.default > div {
    background-color: #0d121c !important;
  }
  &.dark > div {
    background-color: #1c2535 !important;
  }
  &.light > div {
    background-color: #0c316b !important;
  }
}
// .wEditor {
//   // @include set_theme_color(background-color, page-tab-item-bg-color);
//   resize: vertical !important;
// }
</style>
